/* Form component to edit Cast items */
import React, { useState } from "react"
import Form from "react-bootstrap/Form"
import Button from "react-bootstrap/Button"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import styles from "../../styles/Callsheets.module.css"
import btnStyles from "../../styles/Button.module.css"
import Alert from "react-bootstrap/Alert"

import { axiosInstance, axiosReq } from "../../api/axiosDefaults"
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config"
import useHostName from "../../hooks/useHostName";
import toast from "react-hot-toast";

const CallsheetEditCrew2 = (props) => {
  const host = useHostName()
  const [errors, setErrors] = useState({})

  const {
    setShowEdit,
    setCrewNew,
    id1,
    day_id1,  
    position1,
    name1,
    call1,
  } = props

  const [postData, setPostData] = useState({
    day_id: day_id1,
    call: call1,
    position: position1,
    name: name1,
  })

  const {
    day_id,
    call,
  } = postData

  const handleChange = (event) => {
    setPostData({
      ...postData,
      [event.target.name]: event.target.value,
    })
  }

  /* 222222222 NEEDS NEW URL REQUEST 2222222222222222222222222222222222 */
  const handleSubmit = async (event) => {
    event.preventDefault()

    const formData = new FormData()

    formData.append("day_id", day_id)
    formData.append("call", call)
    formData.append("is_second_unit", "true")

    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const { data } = await axiosReq.put(`castcallsnew/${id1}/`, formData)
        const {
          id,
          day_id,
          call,
        } = data
        setCrewNew({
          id1: id,
          day_id1: day_id,
          call1: call,
        });
        toast.success(`Crew Updated`);
        setShowEdit((showEdit) => !showEdit)
      } else {
        const { data } = await axiosInstance.put(
          `${localStorage.getItem("projectSlug")}/castcallsnew/${id1}/`,
          formData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        )
        const {
          id,
          day_id,
          call,
        } = data
        setCrewNew({
          id1: id,
          day_id1: day_id,
          call1: call,
        });
        setShowEdit((showEdit) => !showEdit);
        toast.success(`Crew Updated Successfully!`);
      }
    } catch (err) {
      console.log(err)
      if (err.response?.status !== 401) {
        setErrors(err.response?.data)
      }
    }
  }
  
  const buttons = (
      <div className="mb-2 text-center">    
        <Button
          className={`${btnStyles.Button} ${btnStyles.Blue} px-3 mr-3 `}
          onClick={() => setShowEdit(showEdit => !showEdit)}
        >
          Cancel
        </Button>
        <Button className={`px-3 ml-3 ${btnStyles.Button} ${btnStyles.Blue}`} type="submit">
          Update
        </Button>
      </div>
    );

  return (
    <div >
      <Row>
        <Col className={`${styles.WhiteEdit }`} xs={{span: 10, offset: 1}}>
        <Form className="text-center" onSubmit={handleSubmit}>
          <Row>
          <Col>
          <p style={{fontStyle: 'italic'}} className={`${styles.BoldScene }`}> Edit {position1} </p>
          </Col>
          </Row>
        <Row className="mt-2">
        <Col xs={4} className="d-flex justify-content-center" >
            <Form.Group controlId="call" className={`${styles.Width2} text-center`}  >
                <Form.Label className={`${styles.BoldScene} d-none`} >Call</Form.Label>
                <Form.Control 
                className={`${styles.Input}`} 
                type="text"
                name="call"
                value={call}
                onChange={handleChange}
                    />
            </Form.Group>
            {errors?.call?.map((message, idx) => (
                <Alert variant="warning" key={idx}>
                {message}
                </Alert>
            ))}
        </Col>
        <Col xs={8} >
        {buttons}
        </Col>
        </Row>
          </Form>
        </Col>
      </Row>
    </div>
  )
}

export default CallsheetEditCrew2